import { login, logout, getUserInfo } from '@/api/auth'
import router from '@/router'

const state = {
  token: localStorage.getItem('merchant_token') || '',
  userInfo: JSON.parse(localStorage.getItem('merchant_user') || '{}')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('merchant_token', token)
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('merchant_user', JSON.stringify(userInfo))
  },
  CLEAR_LOGIN(state) {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem('merchant_token')
    localStorage.removeItem('merchant_user')
  }
}

const actions = {
  async login({ commit }, formData) {
    const res = await login(formData)
    if (res.code === 200) {
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data.user)
    }
    return res
  },

  async getUserInfo({ commit }) {
    const res = await getUserInfo()
    if (res.code === 200) {
      commit('SET_USER_INFO', res.data)
    }
    return res
  },

  async logout({ commit }) {
    await logout()
    commit('CLEAR_LOGIN')
    router.push('/login')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}